<card name="Configuration">
  <div card content>
    <form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
      <form-group-context label="Bucket" formControlName="activeBucket">
        <form-group-select bindLabel="label"
                           [searchable]="false"
                           [items]="items"
                           bindValue="value"
                           placeholder="S3"></form-group-select>
      </form-group-context>
      <form-group-context label="Internal" formControlName="internal">
        <form-group-simple type="checkbox" name="internal"></form-group-simple>
      </form-group-context>
      <div class="mt-3">
        <button class="btn btn-success float-right" type="submit">Save</button>
      </div>
    </form>
  </div>
</card>
